import AlmeOverlaySurveyDialog from "../../AlmeOverlayForm/OverlaySurvey/AlmeOverlaySurveyDialog";
import { getSurveyUrl } from "../../../utils/UrlUtils";
import { getCurrentRequiresQualtricsCookieValue } from "../../../utils/RequiresQualtricsCookie";
import React from "react";
import { getCurrentHadLiveChatCookieValue } from "./HadLiveChatQualtricsCookie";
export function isLiveChatSurveyResponse(response) {
    const hasChatEnded = response.extensionData.MessageOrigin === "Session-End";
    const sessionTimedout = !!response.extensionData.isSessionTimeout;
    return (hasChatEnded && !sessionTimedout);
}
const AlmeLiveChartSurveyResponse = (props) => {
    let surveyUrl = props.response.extensionData.surveyUrl;
    if (getCurrentRequiresQualtricsCookieValue() === "true" && getCurrentHadLiveChatCookieValue() === "true") {
        surveyUrl = getSurveyUrl(props.almeAppConfig, true, props.response.extensionData.surveyUrl, props.almeAppConfig.main.isLoggedIn);
    }
    if (!isLiveChatSurveyResponse(props.response) || props.response.fromHistory || (surveyUrl === undefined) || (surveyUrl === '')) {
        return null;
    }
    const handleLiveChatSurveyClose = () => {
        props.markUsedResponse(props.response);
        props.setIsDialogOpen(false);
    };
    return (React.createElement(AlmeOverlaySurveyDialog, { isOpen: true, surveyURL: surveyUrl, onCloseSurvey: handleLiveChatSurveyClose }));
};
export default AlmeLiveChartSurveyResponse;
